import { render, staticRenderFns } from "./SettingsTab.vue?vue&type=template&id=3e686275&scoped=true&"
import script from "./SettingsTab.vue?vue&type=script&lang=js&"
export * from "./SettingsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e686275",
  null
  
)

export default component.exports